<template>
    <div>
        <div v-if="!isEditing && !coderComment" class="mt-4">
            <button 
                @click="startEditing"
                class="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                Add Comment
            </button>
        </div>

        <div v-if="coderComment && !isEditing" class="mt-4">
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <div class="flex justify-between items-start">
                    <h4 class="text-sm font-medium text-gray-900 mb-2">Your Comment</h4>
                    <div class="flex space-x-2">
                        <button 
                            @click="startEditing"
                            class="inline-flex items-center p-1 text-gray-500 hover:text-gray-700 focus:outline-none"
                            title="Edit comment"
                        >
                            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                        </button>
                        <button 
                            @click="deleteComment"
                            class="inline-flex items-center p-1 text-red-500 hover:text-red-700 focus:outline-none"
                            title="Delete comment"
                        >
                            <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
                <p class="text-sm text-gray-600">{{ coderComment }}</p>
            </div>
        </div>

        <div v-if="isEditing" class="mt-4 space-y-4">
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <h4 class="text-sm font-medium text-gray-900 mb-2">{{ coderComment ? 'Edit' : 'Add' }} Comment</h4>
                <textarea
                    v-model="comment"
                    rows="3"
                    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    placeholder="Enter your comment here..."
                ></textarea>
                <div class="mt-4 flex justify-end space-x-3">
                    <button
                        @click="cancelEditing"
                        class="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Cancel
                    </button>
                    <button
                        @click="saveComment"
                        :disabled="!comment.trim()"
                        class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm font-medium rounded text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Save Comment
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        assignment: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditing: false,
            comment: '',
            loading: false,
            coderComment: this.assignment.coder_comment
        }
    },
    methods: {
        startEditing() {
            this.isEditing = true;
            this.comment = this.coderComment || '';
        },
        cancelEditing() {
            this.isEditing = false;
            this.comment = this.coderComment || '';
        },
        async saveComment() {
            if (!this.comment.trim()) return;
            
            this.loading = true;
            try {
                const response = await axios.patch(`/assignments/${this.assignment.id}/comment`, {
                    coder_comment: this.comment
                });
                
                if (response.data.success) {
                    this.$toast.success('Comment saved successfully');
                    this.isEditing = false;
                    this.coderComment = this.comment;
                }
            } catch (error) {
                this.$toast.error('Failed to save comment');
                console.error('Error saving comment:', error);
            } finally {
                this.loading = false;
            }
        },
        async deleteComment() {
            if (!confirm('Are you sure you want to delete this comment?')) return;
            
            this.loading = true;
            try {
                const response = await axios.patch(`/assignments/${this.assignment.id}/comment`, {
                    coder_comment: null
                });
                
                if (response.data.success) {
                    this.$toast.success('Comment deleted successfully');
                    this.coderComment = '';
                }
            } catch (error) {
                this.$toast.error('Failed to delete comment');
                console.error('Error deleting comment:', error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script> 